import { Button } from '@fluentui/react-components';

export const SyncButton = ({ onSync }: { onSync: () => void }) => <Button onClick={onSync}>Sync Partner Center</Button>;
